import { OPEN_IN_BROWSER, ERROR_SHOW, ERROR_TEXT } from './actionTypes';
const defaultState = {
  openInBrowser: true,
  errorShow: false,
  errorText: ''
}

export default (state = defaultState, action) => {
  const newState = JSON.parse(JSON.stringify(state))
  switch (action.type) {
    case OPEN_IN_BROWSER:
      newState.openInBrowser = action.value;
      break;
    case ERROR_SHOW:
      newState.errorShow = action.value;
      break;
    case ERROR_TEXT:
      newState.errorText = action.value;
      break;
    default:
      break;
  }
  return newState
}